import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import SideModal from "components/SideModal";
import NavLink from "components/NavLink";
import SharesValuationBlock from "components/SharesValuationBlock";
import CustomFormatNumber from "components/CustomFormatNumber";
import TwoCellRow from "components/TwoCellRow";
import ExpandableTab from "components/ExpandableTab";
import ExpandableTwoRowDown from "components/SidemodalComponents/ExpandableTwoRowDown";
import GreyBlock from "components/SidemodalComponents/GreyBlock";
import NextButton from "components/NextButton";
import DownloadButton from "components/DownloadButton";
import ExpandLinkIcon from "assets/images/svg/expand-link.svg";
import ArrowRight from "assets/images/svg/arrow-right.svg";
import { useFormattedMessage } from "hooks";
import { getDocumentsHost } from "common/helper";
import {
    payoutTypes,
    SECONDARY_MARKET_PROJECT_STATUS,
    payoutRequestBy,
    getTranslatedCountriesList,
    tenantFancyNames,
    getProductTypeTranslatedLabels,
    getProductCategoriesTranslatedLabels,
} from "constants/index";
import { getProjectInvestmentStatusLookUp } from "utils/statusLookUp";
import { breakCamelCaseWord as breakWord, addDashString } from "utils";
import { sendFormError } from "i18n/messages/errors";

import { selectIsUserAllowedToShowProductDetail } from "store/user/account/selectors";
import NewLoader from "components/NewLoader";
import { selectLocale } from "store/app/selectors";

const DOCUMENT_HOST = getDocumentsHost();

const messages = {
    sendFormError,
    productTitleRequired: "product_title_required",
    productIdRequired: "product_id_required",
    productExist: "product_exist",
    detailView: "payment_details",
    issuer: "nav_issuer",
    productID: "product_id",
    status: "status",
    fundingPercentage: "funding_percentage",
    totalNumberOfShares: "total_number_of_shares",
    availableNumberOfShares: "available_number_of_shares",
    totalNumberOfCreatedInvestments: "total_number_of_created_investments",
    sumOfCreatedInvestments: "sum_of_created_investments",
    totalInvestmentsBeingProcessed: "total_investments_being_processed",
    sumOfInvestmentsBeingProcessed: "sum_of_investments_being_processed",
    payouts: "payouts",
    dividendPayout: "dividend_payout",
    exitPayout: "exit_payout",
    pastPayouts: "past_payouts",
    editPartnerProvision: "edit_partner_provision",
    cashlinkInformation: "cashlink_information",
    productProvision: "product_provision",
    partnerProvision: "partner_provision",
};

const Investments = ({ investmentsGrouped = [], expandTab = false }) => (
    <ExpandableTab expandTab={expandTab} title="Investments">
        <div className="px-4 pt-8 pb-2">
            {investmentsGrouped &&
                investmentsGrouped.map((obj) => (
                    <TwoCellRow
                        key={obj.status}
                        removeLClass
                        containerClassname="mb-6"
                        lClassname="fw-500 text-16"
                        left={obj.status}
                        renderRight={() => (
                            <div className="flex w-40">
                                <span className="text-16 fw-600 text-right w-50">{obj.count}</span>
                                <span className="text-16 fw-600 text-right w-50">{obj.sum}</span>
                            </div>
                        )}
                    />
                ))}
        </div>
    </ExpandableTab>
);

export const FinancialNCostInformation = ({ financialAndCost = {}, title }) => (
    <ExpandableTab title={title}>
        <div className="px-4 pt-8 pb-2">
            {Object.keys(financialAndCost).map((key) => {
                return key === "RunningTimeInYears" ? (
                    <TwoCellRow
                        key={key}
                        removeLClass
                        containerClassname="mb-6"
                        lClassname="fw-500 text-16"
                        left={breakWord(key)}
                        right={"" + financialAndCost[key]}
                    />
                ) : key === "FinancialAmount" ? (
                    <TwoCellRow
                        key={key}
                        removeLClass
                        containerClassname="mb-6"
                        lClassname="fw-500 text-16"
                        left={breakWord(key)}
                        right={<CustomFormatNumber value={financialAndCost[key]} symbol={"€"} />}
                    />
                ) : key === "NumberOfShares" ? (
                    <TwoCellRow
                        key={key}
                        removeLClass
                        containerClassname="mb-6"
                        lClassname="fw-500 text-16"
                        left={breakWord(key)}
                        right={<CustomFormatNumber value={financialAndCost[key]} noSymbol fixed={0} />}
                    />
                ) : (
                    <TwoCellRow
                        key={key}
                        removeLClass
                        containerClassname="mb-6"
                        lClassname="fw-500 text-16"
                        left={breakWord(key)}
                        right={"" + financialAndCost[key] + "%"}
                    />
                );
            })}
        </div>
    </ExpandableTab>
);

export const ProductProvisionInformation = ({ data = {}, title, children = null }) => (
    <ExpandableTab title={title}>
        <div className="px-4 pt-8 pb-2">
            {Object.keys(data).map((key) => {
                return (
                    <TwoCellRow
                        key={key}
                        removeLClass
                        containerClassname="mb-6"
                        lClassname="fw-500 text-16"
                        left={breakWord(key)}
                        right={"" + data[key] + "%"}
                    />
                );
            })}
            {children}
        </div>
    </ExpandableTab>
);

const CashlinkInformation = ({ title = "", _productCashlinkCampaignIDs = {} }) => {
    const productcampaignIDs = Object.keys(_productCashlinkCampaignIDs);

    return (
        <ExpandableTwoRowDown title={title}>
            {productcampaignIDs?.length > 0 &&
                productcampaignIDs.map((item, index) => {
                    return (
                        <div
                            key={index}
                            className="flex row expandable-tabs info-item align-center justify-between"
                            role="button"
                        >
                            <div className="d-flex flex-column py-4 px-5">
                                <h5 className="name my-0 fw-500">{tenantFancyNames[item]}</h5>
                                <label>{_productCashlinkCampaignIDs[item]}</label>
                            </div>
                        </div>
                    );
                })}
        </ExpandableTwoRowDown>
    );
};

const ProductDetailModal = ({
    data,
    onCloseButtonClick,
    open,
    onEditButtonClick,
    isEditable = true,
    isUserAllowedToShowProductDetail,
    onDividendExitButtonClick = () => {},
    activePayoutType,
    payoutRequestedBy,
    onPastPayoutClick = () => {},
    isIssuerManager,
    locale,
    isTenant,
    productProvisionData,
    onEditPartnerProvision = () => {},
    isAdmin = false,
    productCashlinkCampaignIDs,
}) => {
    const {
        product = {},
        investmentsGrouped = [],
        totalInvestmentsBeingProcessed = 0,
        sumOfInvestmentsBeingProcessed = 0,
        totalCreatedInvestments = 0,
        sumOfCreatedInvestments = 0,
        isLoader,
    } = data;

    const { formatMessage } = useFormattedMessage();
    const TRANSLATED_PRODUCT_CATEGORIES = getProductCategoriesTranslatedLabels();
    const TRANSLATED_PRODUCT_TYPE = getProductTypeTranslatedLabels();

    const [sharesValuationBlockData, setShareValuationBlockData] = useState([]);
    const [generalInformation, setGeneralInformation] = useState({});
    const [productAddress, setProductAddress] = useState({});
    const [financialInformation, setFinancialInformation] = useState({});
    const [costsInformation, setCostsInformation] = useState({});
    const [socialMediaInformation, setSocialMediaInformation] = useState({});
    const [documents, setDocuments] = useState([]);
    const [issuerDetails, setIssuerDetails] = useState({});
    const [tokenDetail, setTokenDetail] = useState({});
    const [teaserImage, setTeaserImage] = useState("");
    const [linkIssuer, setLinkIssuer] = useState({});

    const Country =
        (product?.LinkAddress?.Country &&
            getTranslatedCountriesList(locale)?.find((item) => item?.value === product?.LinkAddress?.Country)) ||
        product?.LinkAddress?.Country;

    const isLive = product?.IsLive === "true" || product?.IsLive === true ? true : false;
    const fundingPercentage = product?.fundingPercentage ?? 0;

    const closeButtonClick = () => {
        onCloseButtonClick();
    };

    useEffect(() => {
        setLinkIssuer(product?.Issuer);
    }, [product]);

    useEffect(() => {
        if (typeof product?.ProductID === "undefined") return;
        setTeaserImage("");

        let shareValuationData = [];
        const {
            NumberOfShares,
            Document,
            LinkToken,
            LinkAddress,
            ProductID,
            ProductKey,
            Sorting,
            StatusProduct,
            CategoryProduct,
            TypeProduct,
            Title,
            TitleProductTile,
            Slug,
            FinancingAmount,
            MinimumFundingPercentage,
            TotalReturnEstimated,
            RunningTimeInYears,
            MonetaryBenefitsToInstitute,
            MonetaryBenefitsToBroker,
            OneTimePlacementFee,
            OneTimeGrants,
            OneTimeCostsFi,
            RunningPlacementFeePa,
            RunningGrantsPa,
            RunningCostsFiPa,
            OGURL,
            OGImagePath,
            OGTitle,
            OGDescription,
            ProductContent,
            Issuer,
        } = product;

        shareValuationData = [
            {
                title: formatMessage(messages.totalNumberOfShares),
                value: NumberOfShares,
                symbol: "",
            },
            {
                title: formatMessage(messages.availableNumberOfShares),
                value: NumberOfShares - sumOfCreatedInvestments,
                symbol: "",
            },
            {
                title: formatMessage(messages.totalInvestmentsBeingProcessed),
                value: totalInvestmentsBeingProcessed,
                symbol: "",
                fixed: 0,
            },
            {
                title: formatMessage(messages.sumOfInvestmentsBeingProcessed),
                value: sumOfInvestmentsBeingProcessed,
                symbol: "€",
            },
            {
                title: formatMessage(messages.totalNumberOfCreatedInvestments),
                value: totalCreatedInvestments,
                symbol: "",
                fixed: 0,
            },
            {
                title: formatMessage(messages.sumOfCreatedInvestments),
                value: sumOfCreatedInvestments,
                symbol: "€",
            },
        ];
        setTeaserImage(`${ProductContent?.TeaserImage?.path}?h=300`);

        setGeneralInformation({
            "Product ID": ProductID,
            Title: Title,
            "Marketplace Tile Title": TitleProductTile,
            Status: StatusProduct,
            Category: CategoryProduct && TRANSLATED_PRODUCT_CATEGORIES[CategoryProduct],
            Type: TypeProduct && TRANSLATED_PRODUCT_TYPE?.[TypeProduct],
            Issuer: Issuer?.IssuerEmail,
            Sorting: Sorting,
            Slug: Slug,
            "Product Key": ProductKey,
        });
        setProductAddress({
            uid: LinkAddress?.uid,
            City: LinkAddress?.City,
            Country: Country?.label,
            Street: LinkAddress?.Street,
            StreetAddition: LinkAddress?.StreetAddition,
            Streetnumber: LinkAddress?.Streetnumber,
            TypeAddress: LinkAddress?.TypeAddress,
            Zipcode: LinkAddress?.Zipcode,
        });
        setFinancialInformation({
            FinancialAmount: FinancingAmount,
            NumberOfShares: NumberOfShares,
            "Minimum Funding Percentage": MinimumFundingPercentage,
            "Total Return Estimated": TotalReturnEstimated,
            RunningTimeInYears: RunningTimeInYears,
        });
        setCostsInformation({
            "Monetary Benefits to Institute": MonetaryBenefitsToInstitute,
            "Monetary Benefits to Broker": MonetaryBenefitsToBroker,
            "One Time Placement Fee": OneTimePlacementFee,
            "One Time Grants": OneTimeGrants,
            "One Time Costs Financial Instrument": OneTimeCostsFi,
            "Running Placement Fee Pa.": RunningPlacementFeePa,
            "Running Grants Pa.": RunningGrantsPa,
            "Running Costs Financial Instrument Pa.": RunningCostsFiPa,
        });
        setSocialMediaInformation({
            "OG Url": OGURL,
            "OG Image Path": OGImagePath,
            "OG Title": OGTitle,
            "OG Description": OGDescription,
        });
        setIssuerDetails({
            grouped: {
                "Issuer Name": Issuer?.LegalName,
                "Issuer Email": Issuer?.IssuerEmail,
                "Issuer Website": Issuer?.LinkCompany?.Website,
                "Issuer Street": Issuer?.LinkCompany?.LinkAddress?.Street,
                "Issuer City": Issuer?.LinkCompany?.LinkAddress?.City,
                "Issuer Zipcode": Issuer?.LinkCompany?.LinkAddress?.Zipcode,
            },
            BankAccount: Issuer?.LinkCompany?.LinkBankAccount,
        });
        setTokenDetail({
            "Issuer Name": Issuer?.LegalName,
            "Token Symbol": LinkToken?.TokenSymbol,
            "Token Supply": NumberOfShares,
            "Token Contract": LinkToken?.TokenContract,
        });
        setShareValuationBlockData(shareValuationData);
        setDocuments(Document);
    }, [product]);

    useEffect(() => {
        jQuery(".side-modal").animate({ scrollTop: 0 });
    }, []);

    const { text = "" } = getProjectInvestmentStatusLookUp(product?.StatusProduct);
    return (
        <SideModal
            className="admin-create-product-modal editable-modal"
            open={open}
            onCloseButtonClick={closeButtonClick}
            heading={formatMessage(messages.detailView)}
            containerClassName={"mw-100 pt-0"}
        >
            {isLoader ? (
                <NewLoader type="primary" className="editable-modal-loader" />
            ) : (
                <>
                    {teaserImage ? (
                        <img className="sidepage-banner-image pb-5" src={teaserImage} alt="" />
                    ) : (
                        <div className="placeholder-img d-flex align-center justify-center mb-5">
                            <p className="mb-0">No available project in Takeshape</p>
                        </div>
                    )}
                    <div className="content-part px-5">
                        <div className="d-flex justify-between align-center">
                            <div className="d-flex">
                                {(product?.TypeProduct || product?.CategoryProduct) && (
                                    <span className="text-12 tag fw-600 d-inline-block">
                                        {product?.CategoryProduct
                                            ? `${product?.CategoryProduct} - ${product?.TypeProduct}`
                                            : product?.TypeProduct}
                                    </span>
                                )}
                            </div>
                            <span className="live text-12 fw-600 d-flex align-center">
                                Live <span className={`live-indicator ml-3 ${isLive ? "green" : ""}`} />
                            </span>
                        </div>
                        <div className="mt-5">
                            <label className="another-grey-color">{product?.TitleProductTile}</label>
                            <h5 className="mt-0">
                                <NavLink isExternal href={`/marketplace/${product?.ProductID}`}>
                                    {product?.Title} <ExpandLinkIcon widht="15" height="15" />
                                </NavLink>
                            </h5>
                        </div>
                        <div className="d-flex justify-between">
                            <div className="w-50">
                                <label className="another-grey-color">{formatMessage(messages.productID)}</label>
                                <h5 className="mt-0">{product?.ProductID}</h5>
                            </div>
                            <div className="w-50">
                                <label className="another-grey-color">{formatMessage(messages.status)}</label>
                                <h5 className="mt-0 primary-color">{text}</h5>
                            </div>
                        </div>
                        <div>
                            <label className="another-grey-color">{formatMessage(messages.issuer)}</label>
                            <h5 className="mt-0">{linkIssuer?.IssuerEmail}</h5>
                        </div>
                        <SharesValuationBlock
                            className="black full-size my-10"
                            title={formatMessage(messages.fundingPercentage)}
                            finalValuation={<CustomFormatNumber noSymbol value={fundingPercentage} />}
                            finalValuationSymbol="%"
                            valuations={sharesValuationBlockData}
                        />
                        {isUserAllowedToShowProductDetail && (
                            <>
                                <ExpandableTwoRowDown
                                    title="General Information"
                                    data={generalInformation}
                                    rowContainerClassname="mb-6"
                                />
                                <ExpandableTwoRowDown
                                    title="Product Address"
                                    data={productAddress}
                                    rowContainerClassname="mb-6"
                                />
                                <FinancialNCostInformation
                                    title="Financial Information"
                                    financialAndCost={financialInformation}
                                />
                                <FinancialNCostInformation title="Costs Information" financialAndCost={costsInformation} />
                            </>
                        )}

                        {isAdmin && product?.RegulatoryFramework === "EWPG" ? (
                            <CashlinkInformation
                                title={formatMessage(messages.cashlinkInformation)}
                                _productCashlinkCampaignIDs={productCashlinkCampaignIDs}
                            />
                        ) : null}

                        <ProductProvisionInformation
                            title={formatMessage(messages.productProvision)}
                            data={{
                                [formatMessage(messages.productProvision)]: productProvisionData?.productProvision,
                                ...(isTenant
                                    ? { [formatMessage(messages.partnerProvision)]: productProvisionData?.partnerProvision }
                                    : null),
                            }}
                        >
                            {isTenant ? (
                                <button onClick={() => onEditPartnerProvision(product, productProvisionData?.partnerProvision)}>
                                    {formatMessage(messages.editPartnerProvision)}
                                </button>
                            ) : null}
                        </ProductProvisionInformation>
                        {isUserAllowedToShowProductDetail && (
                            <ExpandableTwoRowDown
                                title="Social Media Information"
                                data={socialMediaInformation}
                                rowContainerClassname="mb-6"
                            />
                        )}
                        {Array.isArray(investmentsGrouped) && investmentsGrouped?.length > 0 && (
                            <Investments investmentsGrouped={investmentsGrouped} expandTab={!isUserAllowedToShowProductDetail} />
                        )}
                        {isUserAllowedToShowProductDetail && (
                            <>
                                <ExpandableTwoRowDown
                                    title="Issuer Information"
                                    data={issuerDetails.grouped}
                                    rowContainerClassname="mb-6"
                                >
                                    <GreyBlock
                                        label="Issuer bank account"
                                        bgClass="bg-dark"
                                        data={issuerDetails.BankAccount || {}}
                                        rChecker={addDashString}
                                        lChecker={breakWord}
                                        rClassName="text-16 fw-500"
                                    />
                                </ExpandableTwoRowDown>
                                <ExpandableTwoRowDown
                                    title="Token Information"
                                    data={tokenDetail}
                                    containerClassname="px-4 pt-8 pb-2"
                                    rowContainerClassname="mb-6"
                                />

                                {documents?.length && (
                                    <ExpandableTwoRowDown title="Documents" rowContainerClassname="mb-6">
                                        {documents.map((item, index) => {
                                            return (
                                                <DownloadButton
                                                    key={index}
                                                    isToken
                                                    fileURL={`${DOCUMENT_HOST}/download/any/${item?.uid}`}
                                                    title={item?.Title}
                                                />
                                            );
                                        })}
                                    </ExpandableTwoRowDown>
                                )}
                                {!isIssuerManager ? (
                                    <>
                                        <ExpandableTab title={formatMessage(messages.payouts)}>
                                            <div className="px-4 pb-2 pt-5">
                                                <div
                                                    className={`menu-tab d-flex align-center justify-between ${
                                                        SECONDARY_MARKET_PROJECT_STATUS.includes(product?.StatusProduct)
                                                            ? "cursor-pointer"
                                                            : "disable pointer-none"
                                                    } ${
                                                        activePayoutType === payoutTypes.DIVIDEND_PAYOUT &&
                                                        payoutRequestedBy === payoutRequestBy.ProductPayoutRequestByIssuer
                                                            ? "px-4 py-2"
                                                            : "p-4"
                                                    }`}
                                                    onClick={() =>
                                                        onDividendExitButtonClick(payoutTypes.DIVIDEND_PAYOUT, product)
                                                    }
                                                >
                                                    <div className="d-flex flex-column">
                                                        <h5 className="name my-0 fw-500">
                                                            {formatMessage(messages.dividendPayout)}
                                                        </h5>
                                                        {activePayoutType === payoutTypes.DIVIDEND_PAYOUT &&
                                                            payoutRequestedBy ===
                                                                payoutRequestBy.ProductPayoutRequestByIssuer && (
                                                                <span className="text-12 secondary-light-color">
                                                                    - Payout amout is required form issuer
                                                                </span>
                                                            )}
                                                    </div>
                                                    <ArrowRight
                                                        className={`arrow mr-0 ${
                                                            SECONDARY_MARKET_PROJECT_STATUS.includes(product?.StatusProduct)
                                                                ? "cursor-pointer"
                                                                : "disable pointer-none"
                                                        }`}
                                                    />
                                                </div>
                                                <div
                                                    className={`menu-tab d-flex align-center justify-between ${
                                                        SECONDARY_MARKET_PROJECT_STATUS.includes(product?.StatusProduct)
                                                            ? "cursor-pointer"
                                                            : "disable pointer-none"
                                                    } ${
                                                        activePayoutType === payoutTypes.EXIT_PAYOUT &&
                                                        payoutRequestedBy === payoutRequestBy.ProductPayoutRequestByIssuer
                                                            ? "px-4 py-2"
                                                            : "p-4"
                                                    }`}
                                                    onClick={() => onDividendExitButtonClick(payoutTypes.EXIT_PAYOUT, product)}
                                                >
                                                    <div className="d-flex flex-column">
                                                        <h5 className="name my-0 fw-500">{formatMessage(messages.exitPayout)}</h5>
                                                        {activePayoutType === payoutTypes.EXIT_PAYOUT &&
                                                            payoutRequestedBy ===
                                                                payoutRequestBy.ProductPayoutRequestByIssuer && (
                                                                <span className="text-12 secondary-light-color">
                                                                    - Payout amout is required form issuer
                                                                </span>
                                                            )}
                                                    </div>
                                                    <ArrowRight
                                                        className={`arrow mr-0 ${
                                                            SECONDARY_MARKET_PROJECT_STATUS.includes(product?.StatusProduct)
                                                                ? "cursor-pointer"
                                                                : "disable pointer-none"
                                                        }`}
                                                    />
                                                </div>
                                                <div
                                                    className={`menu-tab d-flex p-4 align-center justify-between cursor-pointer`}
                                                    onClick={() => onPastPayoutClick()}
                                                >
                                                    <div className="d-flex flex-column">
                                                        <h5 className="name my-0 fw-500">
                                                            {formatMessage(messages.pastPayouts)}
                                                        </h5>
                                                    </div>
                                                    <ArrowRight className={`arrow mr-0 cursor-pointer`} />
                                                </div>
                                                {!SECONDARY_MARKET_PROJECT_STATUS.includes(product?.StatusProduct) && (
                                                    <p className="warning-label">Project is not in marketplace</p>
                                                )}
                                            </div>
                                        </ExpandableTab>
                                        <button className={"w-100 mt-10"}>Publish Project to Live</button>
                                    </>
                                ) : null}
                            </>
                        )}
                    </div>
                    {isEditable && (
                        <div className="bottom-bar-container single-button">
                            <NextButton
                                className={"medium w-100 mr-1 "}
                                title="Edit Product"
                                onClick={() => onEditButtonClick()}
                            />
                        </div>
                    )}
                </>
            )}
        </SideModal>
    );
};

const mapStateToProps = (state) => ({
    locale: selectLocale(state),
    isUserAllowedToShowProductDetail: selectIsUserAllowedToShowProductDetail(state),
});

export default connect(mapStateToProps)(ProductDetailModal);
